import Select from "react-select";
import styled from "styled-components";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { WEBSITE_FONTS } from "../../strings";
import { useTranslation } from "react-i18next";

const SelectContainer = styled.div`
  width: ${({ $asFieldSet }) => ($asFieldSet ? "100%" : "250px")};
`;

// Font Options
const options = [
  { value: WEBSITE_FONTS.DEFAULT, label: "Default" },
  {
    value: WEBSITE_FONTS.CLASH_DISPLAY_SEMI_BOLD,
    label: "Clash Display - Semi Bold"
  },
  { value: WEBSITE_FONTS.SATOSHI_BOLD, label: "Satoshi - Bold" },
  { value: WEBSITE_FONTS.SATOSHI_MEDIUM, label: "Satoshi - Medium" },
  { value: WEBSITE_FONTS.SATOSHI_REGULAR, label: "Satoshi - Regular" }
];

const FontSelector = ({
  formField,
  isFormChanged,
  asFlex = false,
  asFieldSet = false
}) => {
  const { t } = useTranslation();
  const { setValue, getValues } = useFormContext();
  const _key = "selectedFont";

  const getSelectValue = () =>
    getValues(`${formField}.${_key}`)
      ? options.find(({ value }) => value === getValues(`${formField}.${_key}`))
      : options[0];

  const handleOnChangeFont = (option) => {
    setValue(`${formField}.${_key}`, option.value);
    isFormChanged.current = true;
  };

  return (
    <Form.Group className={`${asFlex ? "d-flex align-items-center" : ""} mb-2`}>
      <Form.Label className={asFieldSet ? "" : "mb-0"}>
        {t("common.select")} {t("common.font")}:
      </Form.Label>
      <SelectContainer
        className={asFieldSet ? "" : "ms-2"}
        $asFieldSet={asFieldSet}
      >
        <Select
          className="w-100"
          options={options}
          value={getSelectValue()}
          getOptionValue={(opt) => opt?.value}
          getOptionLabel={(opt) => opt?.label}
          onChange={(option) => handleOnChangeFont(option)}
        />
      </SelectContainer>
    </Form.Group>
  );
};
export default FontSelector;
